import styled from 'styled-components';

export const STDLogo = styled.div`
  width: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  transition: transform 0.3s ease-in 0s;
  position: absolute;
  top: 0px;

  &.headerDown {
    @media (min-width: 0px) {
      transform: translateY(calc(37px));
    }
    @media (min-width: 560px) {
      transform: translateY(calc(33px));
    }
    @media (min-width: 960px) {
      transform: translateY(calc(29px));
    }
    @media (min-width: 1920px) {
      transform: translateY(calc(33px));
    }
  }
  &.headerUp {
    @media (min-width: 0px) {
      transform: translateY(calc(-37px));
    }
    @media (min-width: 560px) {
      transform: translateY(calc(-33px));
    }
    @media (min-width: 960px) {
      transform: translateY(calc(-29px));
    }
    @media (min-width: 1920px) {
      transform: translateY(calc(-33px));
    }
  }
`;
export const DivLogo = styled.span`
  display: grid;
  -webkit-box-align: center;
  align-items: center;
  width: 100%;
  --logo-size: 32px;
  --margin-size: 8px;
  grid-template-columns: auto max-content auto;
  column-gap: var(--margin-size);
  @media (min-width: 560px) {
    grid-template-columns: auto max-content auto;
    --logo-size: 40px;
    --margin-size: 10px;
  }
  @media (min-width: 960px) {
    grid-template-columns: calc(var(--size-grid016) - var(--margin-size)) max-content auto;

    --logo-size: 48px;
    --margin-size: 12px;
  }
  @media (min-width: 1920px) {
   
    --logo-size: 56px;
    --margin-size: 14px;
  }
  @media (min-width: 2560px) {   
    
    grid-template-columns: calc(426.6666666666667px + 50vw - var(--margin-size))max-content auto;

   --logo-size: 56px;
   --margin-size: 14px;
 }
  
  svg {
    fill: rgb(0, 30, 80);
    width: var(--logo-size);
    height: var(--logo-size);
  }

  &::before,
  &::after {
    content: '';
    height: 2px;
    background: rgb(0, 30, 80);
  }
`;

